import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
import { HeroAvatars } from './HeroAvatars';
import { mainGuide } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
type HeroProps = {
  draftPreview: boolean;
};
export function Hero({
  draftPreview
}: HeroProps) {
  const [videoFailed, setVideoFailed] = useState(false);
  const showVideo = Boolean(siteConfig.heroVideoUrl) && !videoFailed;
  const {
    trust,
    heroBadge
  } = siteConfig;
  const showTrust = trust.confirmed;
  const ratingLabel = trust.rating.toLocaleString('nl-NL');
  return <section className="bg-cream px-5 sm:px-8 pt-8 pb-12 sm:pt-14 sm:pb-16 overflow-hidden" data-id="element-90" data-mp="sb1axo5hpx5i">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-91" data-mp="nc876ng09kij">
        <p className="inline-flex items-center rounded-full border border-berry-deep/40 px-3 sm:px-4 py-1.5 text-xs font-semibold tracking-[0.04em] sm:tracking-[0.12em] whitespace-normal text-berry-deep" data-id="element-92" data-mp="neaz5d0pxnpw">
          KIES · VORM · PERSONALISEER · MAAK
        </p>

        <h1 className="mt-5 font-serif text-[2.15rem] leading-[1.1] sm:text-5xl lg:text-[3.6rem] font-semibold text-plum text-balance" data-id="element-93" data-mp="3j9u2j3pddwnx">
          Maak van een eenvoudig koord{' '}
          <span className="italic font-medium text-berry-deep" data-id="element-94" data-mp="39b4gcyqfxq1v">iets moois, gemaakt met liefde</span>.
        </h1>

        <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-95" data-mp="3e8ecex8c4zyo">
          Maak zelf namen, decoraties en persoonlijke cadeaus met punnikkoord. Een praktische handleiding, een verzameling sjablonen en vier bonussen om mee te beginnen en nieuwe ideeën op te doen, ook als je nog nooit hebt gepunnikt.
        </p>

        {showTrust && <div className="mt-6 inline-flex max-w-full items-center gap-3 rounded-[1.75rem] sm:rounded-full border border-butter-deep/40 bg-cream px-4 py-2.5 shadow-soft text-left" data-id="element-96" data-mp="2qi0nvgoylj8u">
            <HeroAvatars data-id="element-97" data-mp="2hl9s75ebk6es" />
            <span className="flex min-w-0 flex-col sm:flex-row sm:items-center gap-x-2 gap-y-0.5" data-id="element-98" data-mp="2lkilya9d04ac">
              <span className="flex items-center gap-2" data-id="element-99" data-mp="s1rqcip57wrn">
                <span className="flex gap-0.5 text-butter-deep" role="img" aria-label={`Gemiddelde beoordeling ${ratingLabel} van 5`} data-id="element-100" data-mp="s3ckw8bgjfpi">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} aria-hidden="true" className="fill-current" data-id="element-101" data-mp="ici0zaloos78" data-mpi={i} />)}
                </span>
                <span className="text-sm font-semibold text-ink whitespace-nowrap" data-id="element-102" data-mp="dbaqv4w2jgxe">
                  {ratingLabel} / 5
                </span>
              </span>
              <span className="text-sm text-ink/80" data-id="element-103" data-mp="16342sk53hg8s">
                <span aria-hidden="true" className="hidden sm:inline" data-id="element-104" data-mp="112g6biy3k776">· </span>
                {trust.customerLabel}
              </span>
            </span>
          </div>}

        <div className="relative mt-9 w-full max-w-[340px] sm:max-w-[400px]" data-id="element-105" data-mp="x37am8jhxz8z">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border-[6px] border-white bg-blush shadow-frame ring-1 ring-berry/30" data-id="element-106" data-mp="3lui86njf0tjs">
            {showVideo ? <video src={siteConfig.heroVideoUrl} poster={mainGuide.image || undefined} autoPlay muted loop playsInline controls={false} disablePictureInPicture disableRemotePlayback preload="auto" onError={() => setVideoFailed(true)} aria-label="Video met voorbeelden van creaties met punnikkoord" className="h-full w-full object-cover object-center" data-id="element-107" data-mp="1xa41v91w2agz" /> : <div className="h-full w-full flex items-center justify-center p-6 text-center" data-id="element-108" data-mp="2b20s17jzyaaq">Punniken met Liefde</div>}
          </div>
          <span className="pointer-events-none absolute -top-3 right-3 flex h-[84px] w-[84px] flex-col items-center justify-center rounded-full bg-berry-deep px-1.5 text-center text-white shadow-soft ring-4 ring-cream" data-id="element-109" data-mp="2kyvqxrk6mcpj">
            <span className="font-serif text-[22px] font-bold leading-none whitespace-nowrap" data-id="element-110" data-mp="2tztu67msqg72">{heroBadge.value}</span>
            <span className="mt-1 text-[11px] font-semibold leading-none whitespace-nowrap" data-id="element-111" data-mp="unixt5i1ugi7">{heroBadge.label}</span>
          </span>
        </div>

        <a href="#pakket" className="mt-9 inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center whitespace-normal rounded-full bg-berry-deep px-4 sm:px-9 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200 hover:bg-berry-darker" data-id="element-112" data-mp="zndp3a5ql83s">
          Bekijk het pakket
        </a>
        <p className="mt-3.5 text-sm text-ink/70" data-id="element-113" data-mp="9aql850ptotb">
          Eenmalige betaling · Digitaal product · Materialen niet inbegrepen
        </p>
      </div>
    </section>;
}